// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"L9-z","disabled":"M9-z","label":"N9-z"};